module.exports = __webpack_public_path__ + "img/Qcorazon.63afa62b.png";